// Auto-generated enum types and metadata
// DO NOT EDIT - Changes will be overwritten

export enum AttributeDataType {
  STRING = "string",
  INTEGER = "integer",
  REAL = "real",
  BOOLEAN = "boolean",
  DATETIME = "datetime",
}
